import { FileSystemItem } from "types";
import { useTranslation } from "react-i18next";

export const FolderStats = ({ fileItems }: { fileItems: FileSystemItem[] }) => {
  const { t } = useTranslation();
  const totalItems = fileItems.length;
  const foldersCount = fileItems.filter(
    (item) => item.type === "Folder"
  ).length;
  const filesCount = fileItems.filter(
    (item) => item.type === "Document"
  ).length;
  const workflowsCount = fileItems.filter(
    (item) => item.type === "Workflow"
  ).length;

  // If there are workflows, show workflows count instead of files count
  const hasWorkflows = workflowsCount > 0;

  return (
    <div className="mt-6 text-sm text-gray-600">
      {t("library.stats.items", { count: totalItems })} •{" "}
      {t("library.stats.folders", { count: foldersCount })} •{" "}
      {hasWorkflows
        ? t("library.stats.workflows", { count: workflowsCount })
        : t("library.stats.files", { count: filesCount })}
    </div>
  );
};
